import { useListSelectionContext } from "--floponents-web/molecules/ListEntries/ListSurface/ListSelectionContext";
import Color from "color";
import * as React from "react";
import styled from "styled-components"
// Works with the ListSurface component to style child list items
export const StyledListEntrySurfaceHighlight = styled.div<{ allowClickThrough?: boolean }>`
    &>* {
        ${props => !props.allowClickThrough ? `pointer-events:none;` : undefined}
    };
    cursor: pointer;
    :hover {
        background: ${props => props.theme.palette.ui.highlight
    };
    }
    &._list_active {
        background: ${props => Color(props.theme.palette.primary.main).alpha(0.2).toString()};
    }

    &._list_active &:hover {
        background: ${props => props.theme.palette.surface};
    }
`;

export type ListEntrySurfaceHighlightProps = { index: number, allowClickThrough?: boolean } & React.HTMLAttributes<HTMLDivElement>
//this component applies active styling, scrolls the entry into view as required and allows selection by mouse over
export const ListEntrySurfaceHighlight: React.FC<ListEntrySurfaceHighlightProps> = props => {
    const { index, ...wrapperProps } = props;

    const highlighted = useListSelectionContext(props.index);
    const thisRef = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        const listItem = thisRef.current;
        if (!listItem || highlighted?.value.by !== "keyboard" || highlighted.value.selected !== index) return;
        const container = listItem.parentElement as HTMLElement;
        const itemCenter = listItem.offsetTop + listItem.offsetHeight / 2;
        const scrollPos = container.scrollTop + container.offsetHeight / 2;
        container.scrollBy({ behavior: "smooth", top: itemCenter - scrollPos });
    }, [highlighted?.value.by, highlighted.value.selected]);

    const handleMouseEnter = () => {
        if (highlighted?.value.selected !== props.index)
            highlighted.next({ by: "mouse", selected: props.index });
    }

    const handleMouseDown = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
    }

    const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        e.preventDefault();
        wrapperProps.onClick?.(e);
    }

    return <StyledListEntrySurfaceHighlight
        ref={thisRef}
        {...wrapperProps}
        data-ls-highlight={highlighted.value.selected === index}
        onMouseEnter={handleMouseEnter}
        onMouseDown={handleMouseDown}
        onClick={handleClick} />
};